import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import InspectorDetailBody from '../InspectorDetailBody';

// Descriptor for the Inspector engine — the 5th Security Hub capability. Same
// shape as cspm.js / guardduty.js / macie.js; registering it in registry.js
// auto-wires the sidebar, Overview tiles, the EnableCapabilities panel and the
// unified findings inbox.
//
// `capability` here is DEAD DATA — EnableCapabilities reads the capability copy
// off the API response (row.capability), never off this object. The user-visible
// copy lives in Go, in securityhub_engine_inspector.go's Capability(); the block
// is kept only for shape-parity with the sibling descriptors, and is transcribed
// from that Go source so the two cannot disagree if it ever is wired up.
export const inspectorEngine = {
  id: 'inspector', // MUST equal the backend Engine.ID()
  label: 'Amazon Inspector',
  color: '#7D3C98',
  Icon: BugReportOutlinedIcon,
  // NOTE: the card's copy (name/source/description/items) is served by the
  // BACKEND — EnableCapabilities reads `row.capability` from /capabilities and
  // falls back to `{}`, never to this file. A duplicate here was already drifting
  // from Go's Capability() on at least one engine, so it was removed rather than
  // left to be trusted. Change the copy in securityhub_engine_<id>.go.
  // Sidebar sub-items. They hang directly off the SECURITY HUB group —
  // there is no "Detection engines" grouping in PortalSidebar.
  // Routes are NOT generated from this list — every entry needs a matching
  // <Route> in App.js or it falls through to the catch-all redirect.
  nav: [
    { label: 'Dashboard', to: '/securityhub/inspector' },
    { label: 'Findings', to: '/securityhub/inspector/findings' },
    { label: 'Enrollment', to: '/securityhub/inspector/enrollment' },
    { label: 'Settings', to: '/securityhub/inspector/settings' },
  ],
  enableRoute: '/securityhub/inspector', // where "Enable/Configure" routes
  DetailBody: InspectorDetailBody,
};
